const CAPTCHA_CLIENT_KEY = 'captcha_client_id';
let memoryClientId = '';

function newClientId() {
  try {
    if (window.crypto && typeof window.crypto.randomUUID === 'function') {
      return window.crypto.randomUUID();
    }
  } catch (e) { /* use fallback */ }
  return `${Date.now().toString(36)}-${Math.random().toString(36).slice(2)}-${Math.random().toString(36).slice(2)}`;
}

// Give every browser tab an anonymous ID so captcha telemetry does not have to
// merge unrelated users behind the same public IP. The server only logs an HMAC.
export function captchaClientId() {
  if (memoryClientId) return memoryClientId;
  try {
    memoryClientId = window.sessionStorage.getItem(CAPTCHA_CLIENT_KEY) || '';
    if (!memoryClientId) {
      memoryClientId = newClientId();
      window.sessionStorage.setItem(CAPTCHA_CLIENT_KEY, memoryClientId);
    }
  } catch (e) {
    // Privacy modes can disable sessionStorage. An in-memory ID still keeps the
    // business request working and remains stable for the current page lifetime.
    memoryClientId = newClientId();
  }
  return memoryClientId;
}
